import { BRANDS } from "../content";
import { Diamond } from "../lib/icons";

export const Marquee = () => {
  const doubled = [...BRANDS, ...BRANDS];
  return (
    <section
      data-testid="brands-marquee-section"
      aria-label="Clientes"
      className="bg-tinta border-y border-inkline py-10 md:py-12 overflow-hidden"
    >
      <p
        data-testid="brands-marquee-label"
        className="label-caps text-muteddark text-center mb-7 px-5"
      >
        Clientes
      </p>
      <div className="relative">
        <div className="marquee-track items-center gap-8 pr-8">
          {doubled.map((brand, i) => (
            <span key={`${brand}-${i}`} className="flex items-center gap-8 shrink-0">
              <span className="font-sora font-semibold text-creme/75 text-sm md:text-base whitespace-nowrap tracking-[-0.02em]">
                {brand}
              </span>
              <Diamond />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
